import { TableBodyProps, Tbody } from '@chakra-ui/table';
import React from 'react';

export const CmTbody: React.FC<TableBodyProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <Tbody {...rest} />;
};
